<template>
  <div>
    <Row align="middle" type="flex" class-name="column-bar">
      <Col span=4>
      <column-title :title="$t('pages_dashboards_statement_product_index_370')" class="column-bar__tit"/>
      </Col>
      <Col span="20">
      <tabs-time-picker :time.sync="currentTime" @change="changeTime"/>
      </Col>
    </Row>
    <Summary :data="statement_product_summary" ></Summary>
    <Row align="middle" type="flex" class-name="column-bar">
      <Col span="4">
      <column-title :title="$t('pages_dashboards_statement_product_index_371')" class="column-bar_tit"/>
      </Col>
    </Row>
    <Row align="middle" type="flex" class-name="column-bar">
      <Col span="22">
        <Menu mode="horizontal" :active-name="activeName" @on-select="selectMenu">
            <Submenu name="1">
                <template slot="title">
                    <Icon type="ios-stats" />{{$t('pages_dashboards_statement_product_index_372')}}</template>
                    <MenuItem name="frontProductDetail">{{$t('pages_bookings_new_232')}}</MenuItem>
                    <MenuItem name="frontCateogryDetail">{{$t('pages_booking_store_products_index_213')}}</MenuItem>
            </Submenu>
            <Submenu name="3">
              <template slot="title">
                  <Icon type="ios-stats" />{{$t('pages_dashboards_statement_product_index_373')}}</template>
                  <MenuItem name="wechatProductDetail">{{$t('pages_bookings_new_232')}}</MenuItem>
                  <MenuItem name="wechatCateogryDetail">{{$t('pages_booking_store_products_index_213')}}</MenuItem>
          </Submenu>
        </Menu>
      </Col>
      <Col span="2">
        <el-button
          type="primary"
          size="medium"
          @click="exportData"
          icon="el-icon-download"
        >{{$t('pages_customers_index_311')}}</el-button>
      </Col>
    </Row>
    <i-table
        v-for="(item, name) of columns"
        :key="name"
        :ref="name"
        v-show="name === activeName"
        :highlight-row="true"
        :columns="item"
        :data="statement_product_table_data[name]">
    </i-table>
  </div>
</template>
<script>
import i18n from '../../../locales/index'

import ColumnTitle from '_c/column-title'
import TabsTimePicker from '_c/tabs-time-picker'
import Summary from './components/summary'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'home',
  components: {
    ColumnTitle,
    TabsTimePicker,
    Summary
  },
  data () {
    return {
      activeName: 'frontProductDetail',
      currentTime: [],
      columns: {
        frontProductDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'fresh_product_name',
            title: i18n.t('pages_bookings_detail_222'),
          },
          {
            key: 'fresh_category_name',
            title: i18n.t('pages_booking_store_products_index_213'),
          },
          {
            key: 'total_price',
            title: i18n.t('pages_dashboards_statement_product_index_375'),
          },
          {
            key: 'quantity',
            title: i18n.t('pages_dashboards_statement_product_index_376'),
          },
          {
            key: 'percentage',
            title: i18n.t('pages_dashboards_statement_product_index_377'),
          },
          {
            key: 'order_counts',
            title: i18n.t('pages_dashboards_statement_product_index_378'),
          },
          {
            key: 'maoli',
            title: i18n.t('pages_dashboards_statement_product_components_summary_369'),
          }
        ],
        frontCateogryDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'fresh_category_name',
            title: i18n.t('pages_booking_store_products_index_213'),
          },
          {
            key: 'total_price',
            title: i18n.t('pages_dashboards_statement_product_index_375'),
          },
          {
            key: 'percentage',
            title: i18n.t('pages_dashboards_statement_product_index_377'),
          },
          {
            key: 'order_counts',
            title: i18n.t('pages_dashboards_statement_product_index_379'),
          },
          {
            key: 'maoli',
            title: i18n.t('pages_dashboards_statement_product_components_summary_369'),
          }
        ],
        wechatProductDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'fresh_product_name',
            title: i18n.t('pages_bookings_detail_222'),
          },
          {
            key: 'fresh_category_name',
            title: i18n.t('pages_booking_store_products_index_213'),
          },
          {
            key: 'total_price',
            title: i18n.t('pages_dashboards_statement_product_index_375'),
          },
          {
            key: 'quantity',
            title: i18n.t('pages_dashboards_statement_product_index_376'),
          },
          {
            key: 'percentage',
            title: i18n.t('pages_dashboards_statement_product_index_377'),
          },
          {
            key: 'order_counts',
            title: i18n.t('pages_dashboards_statement_product_index_378'),
          },
          {
            key: 'maoli',
            title: i18n.t('pages_dashboards_statement_product_components_summary_369'),
          }
        ],
        wechatCateogryDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'fresh_category_name',
            title: i18n.t('pages_booking_store_products_index_213'),
          },
          {
            key: 'total_price',
            title: i18n.t('pages_dashboards_statement_product_index_375'),
          },
          {
            key: 'percentage',
            title: i18n.t('pages_dashboards_statement_product_index_377'),
          },
          {
            key: 'order_counts',
            title: i18n.t('pages_dashboards_statement_product_index_379'),
          },
          {
            key: 'maoli',
            title: i18n.t('pages_dashboards_statement_product_components_summary_369'),
          }
        ],
      }
    }
  },
  computed: {
    ...mapGetters('dashboard', ['statement_product_summary', 'statement_product_table_data']),
  },
  methods: {
    ...mapActions('dashboard', ['getStatementProduct']),
    async exportData () {
      const filenameMap = new Map([
        ['frontProductDetail', i18n.t('pages_dashboards_statement_product_index_380')],
        ['frontCateogryDetail', i18n.t('pages_dashboards_statement_product_index_381')],
        ['wechatProductDetail', i18n.t('pages_dashboards_statement_product_index_382')],
        ['wechatCateogryDetail', i18n.t('pages_dashboards_statement_product_index_383')],
      ])
      this.$refs[this.activeName][0].exportCsv({
        columns: this.columns[this.activeName],
        data: this.statement_product_table_data[this.activeName],
        filename: filenameMap.get(this.activeName)
      })
    },
    selectMenu (data) {
      this.activeName = data;
    },
    changeTime (data) {
      console.log(this.currentTime);
      this.getStatementProduct({
        start_at: this.currentTime[0],
        end_at: this.currentTime[1]
      });
    }
  },
  created () {},
  mounted () {},
  destroyed () {}
}
</script>

<style lang="less" scoped>
.column-bar{
  margin-bottom: 20px;
  padding-bottom: 10px;
  background: #fff;
  &__tit{
    margin-left: 10px;
  }
}
.count-head {
  font-size: 20px;
}
.count-sub {
  font-size: 16px;
}
</style>
